/** Taking an appointment at the front desk, from the diary. Conventions: see `common.ts`. */
const deskBooking: Record<string, string> = {
  open: 'New appointment',
  title: 'New appointment',
  loading: 'Loading your booking calendars…',
  load_error: 'The booking calendars could not be loaded. Please try again.',
  empty: 'There is nothing to book yet. Add a bookings section with at least one service to your shop first.',

  calendar: 'Calendar',
  service: 'Service',
  service_duration: '{name} · {minutes} min',
  person: 'With',
  anyone: 'Anyone available',
  date: 'Date',

  'slots.title': 'Time',
  'slots.loading': 'Finding free times…',
  'slots.error': 'Free times could not be loaded.',
  'slots.none': 'Nothing free on this day. Try another date or person.',
  'slots.left_one': '{count} left',
  'slots.left_other': '{count} left',
  'slots.full': 'Full',
  'slots.free_with': 'Free: {names}',
  'slots.pick': 'Pick a time.',

  'customer.title': 'Customer',
  'customer.existing': 'Existing customer',
  'customer.new': 'New customer',
  'customer.search': 'Find a customer',
  'customer.search_placeholder': 'Name, email or phone…',
  'customer.searching': 'Searching…',
  'customer.no_results': 'No customer matches. Add them as a new customer instead.',
  'customer.change': 'Change',
  'customer.pick': 'Choose a customer, or add a new one.',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  contact_hint: 'Optional. A name and a phone number are all a booking needs.',
  'errors.name_required': 'Enter the customer\'s name.',
  'errors.phone_required': 'Enter the customer\'s phone number.',
  'errors.customer_no_phone': 'This customer has no phone number. Add one on their customer page, or book them as a new customer.',
  'errors.email_invalid': 'That email address does not look right.',
  'errors.address_required': 'Enter the address to visit.',

  address: 'Customer\'s address',
  address_hint: 'This service happens at the customer\'s address.',
  notes: 'Notes',
  notes_placeholder: 'Anything the team should know',
  questions: 'Booking questions',
  questions_hint: 'Optional at the front desk.',
  choose_option: 'Choose…',

  confirm: 'Mark as confirmed',
  confirm_hint: 'Booked on the phone is agreed already. Leave unticked to keep it as needing a reply.',
  notify: 'Send the customer a confirmation',
  notify_hint: 'By email, and on WhatsApp if they agreed to updates.',
  notify_no_email: 'No email address and no WhatsApp consent, so nothing will be sent.',

  submit: 'Book appointment',
  submitting: 'Booking…',
  created: 'Appointment booked for {name}.',
  'errors.BOOKING_PHONE_REQUIRED': 'Give a phone number for the booking.',
  'errors.BOOKING_SLOT_UNAVAILABLE': 'That time has just been taken, or is somebody\'s time off. Pick another time.',
  'errors.failed': 'The appointment could not be booked.',

  added_by_desk: 'Added at the front desk',
  no_email: 'No email address',

  'follow_up.title': 'Book a follow-up',
  'follow_up.of': 'Follow-up of {name}\'s {service} on {when}.',
  'follow_up.after': 'After the visit:',
  'follow_up.days_7': '+7 days',
  'follow_up.days_15': '+15 days',
  'follow_up.days_30': '+1 month',
  'follow_up.days_90': '+3 months',

  'follow_up.book': 'Book follow-up',
  'follow_up.book_again': 'Book again',
  'follow_up.is_follow_up': 'Follow-up of the {when} visit',
  'follow_up.booked_for': 'Follow-up booked for {when}',
};

export default deskBooking;
